module.exports = __webpack_public_path__ + "static/media/deleteimg.407f2872.png";